export enum ManageCardsRoute {
  List = 'list',
  Scan = 'scan',
  Assign = 'assign',
}
